import React from 'react';
import { MainLayout } from './components/Layout/MainLayout';
import { ModuleProvider } from './contexts/ModuleContext';
import { UIModelProvider } from './contexts';
import { TParty } from '../../../../types/Context/AppContext';

type UIModelsModule1Props = {
  projectId: string;
  userId: string;
  userProjectDataModels: any;
  channelId: string;
  industryId?: string;
  selectedParty: TParty;
  refreshRef?: React.MutableRefObject<(() => void) | null>;
  onFreestyleUIModelChange?: (hasFreestyle: boolean) => void;
};

export const UIModelsModule1 = ({
  projectId,
  userId,
  userProjectDataModels,
  channelId,
  industryId = '',
  selectedParty,
  refreshRef,
  onFreestyleUIModelChange,
}: UIModelsModule1Props) => {
  return (
    <ModuleProvider industryId={industryId} userId={userId} userProjectDataModels={userProjectDataModels}>
      <UIModelProvider configureId={projectId}>
        <MainLayout
          projectId={projectId}
          userProjectDataModels={userProjectDataModels}
          selectedParty={selectedParty}
          refreshRef={refreshRef}
          onFreestyleUIModelChange={onFreestyleUIModelChange}
        />
      </UIModelProvider>
    </ModuleProvider>
  );
};

export default UIModelsModule1;
